import React, { useEffect, useState } from 'react'
import { PLZMap } from './map'
import { scaleLinear, scaleThreshold } from 'd3-scale'
import { ButtonGroup, Button } from '@material-ui/core'
import Chart from 'components/Charts_Chart'
import * as ss from 'simple-statistics'
import { formatSwissDate, nF } from 'components/Charts_Assets'
import './styles.scss'
const bivariate = [
  '#f1efe9',
  '#c2dcd6',
  '#91c8c2',
  '#5fb3ae',
  '#2b9d98',
  '#e9c5c3',
  '#bbb5b3',
  '#8ca4a2',
  '#5c9392',
  '#29817f',
  '#e19a9b',
  '#b48e8e',
  '#878081',
  '#597374',
  '#286565',
  '#d86c71',
  '#ad6368',
  '#825a5e',
  '#555154',
  '#26474a',
  '#cd323c',
  '#a52e37',
  '#7b2a32',
  '#51262d',
  '#242127' 
]

const scaleCases = scaleThreshold<number, string>()
  .domain([0, 60])
  .range(['#EFECE0', '#E9999F', '#DE666F', '#D3343F', '#9E272F', '#691A1F'])

const scaleVacc = scaleThreshold<number, string>()
  .domain([0, 100])
  .range(['#EFECE0', '#95D0CF', '#60B9B7', '#2CA29F', '#217977', '#16514F'])

const scaleCasesInz = scaleLinear<string, string, never>()
  .domain([0, 400])
  .range(['#EFECE0', '#d3343f'])

// const scaleVacc = scaleLinear<string, string, never>()
//   .domain([45, 80])
//   .range(['#EFECE0', '#2ca29f'])

let categorizeCases = scaleThreshold()
  .domain([100, 200, 500, 800])
  .range([0, 1, 2, 3, 4])

let categorizeVacc = scaleThreshold()
  .domain([40, 50, 60, 70])
  .range([0, 1, 2, 3, 4])

export const Geografic = () => {
  type drawDataType = {
    plz: string
    name: string
    cases: string
    casesRel: number
    caseDate: string
    vacc: number
    vaccDate: string
    vaccRel: number
  }[]
  function roundnum(num, to) {
    return Math.round(num / to) * to
  }
  const [drawData, setDrawData] = useState<drawDataType | undefined>()

  const [showTable, setShowTable] = useState<boolean>(false)
  useEffect(() => {
    const files = [
      fetch(
        'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-CasesPlz.json'
      ).then(response => response.json()),
      fetch(
        'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-VaccPlz.json'
      ).then(response => response.json()),
      fetch(
        'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-CasesVaccPlz.json'
      ).then(response => response.json())
    ]
    Promise.all(files).then(results => {
      setDrawData(results[2])
    })
  }, [])

  let colorizer = (value: number[]) => {
    if (!value) return '#ccc'
    let [a, b] = value
    return bivariate[Math.round(categorizeVacc(b)) + categorizeCases(a) * 5]
  }
  if (drawData) {
    let cats = ss
      .ckmeans(
        drawData.map(m => m.casesRel).filter(f => f > 0),
        6
      )
      .map(m => roundnum(m[0], 50))
    scaleCases.domain(cats)

    cats = ss
      .ckmeans(
        drawData.map(m => m.vaccRel).filter(f => f > 0),
        6
      )
      .map(m => roundnum(m[0], 5))
    cats.shift()
    scaleVacc.domain(cats)
  }
  return (
    <>
      {' '}
      <div className='ui text container'>
        <div className='segmenttitle'>Räumliche Verteilung</div>
        <div className='selectContainer'>
          <ButtonGroup
            color='primary'
            aria-label='outlined primary button group'
          >
            <Button
              className={!showTable ? 'selected' : ''}
              onClick={() => {
                setShowTable(false)
              }}
            >
              Karte
            </Button>
            <Button
              className={showTable ? 'selected' : ''}
              value='selected'
              onClick={() => {
                setShowTable(true)
              }}
            >
              Tabelle
            </Button>
          </ButtonGroup>
        </div>
      </div>{' '}
      <div className='ui  container'>
        <div className='Geografic'>
          {!showTable && (
            <div className='mapwrapper'>
              <div className='left'>
                <Chart
                  title={'7-Tages-Inzidenz'}
                  sub={
                    drawData
                      ? "Positiv getestete Personen in den letzten 7 Tagen pro 100'000 Personen" +
                        (', bis ' +
                          formatSwissDate(
                            drawData[drawData.length - 1].caseDate
                          ))
                      : undefined
                  }
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_plz/fallzahlen_kanton_ZH_plz.csv'
                        target='_blank'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                  footnote={
                    'Beige = Mit 0-3 Fällen pro Woche zu wenig für eine sinnvolle Berechnung. Für die Berechnung der Inzidenz verwenden wir den Mittelwert der angegebenen Spannbreite der Fälle der Gesundheitsdirektion Zürich.  Ausschlaggebend ist der Wohnort der Infizierten.'
                  }
                >
                  <ColorKey
                    data={[0].concat(scaleCases.domain()).map(m => {
                      return {
                        color: scaleCases(m) + '',
                        label: m === 0 ? 'n.V.' : m + ''
                      }
                    })}
                  />
                  {drawData && (
                    <PLZMap
                      data={drawData.map(el => {

                        const { casesRel, plz } = el

                        let color =
                          casesRel >= 0 ? scaleCases(casesRel) : '#eee'
                        return [plz, color, casesRel, el]
                      })}
                      Tooltip={Tooltip}
                    />
                  )}
                </Chart>
              </div>
              <div className='right'>
                <Chart
                  title={'Impfquote'}
                  sub={
                    drawData
                      ? 'Anteil der Gesamtbevölkerung, welcher mindestens einmal geimpft ist' +
                        (', bis ' +
                          formatSwissDate(
                            drawData[drawData.length - 1].caseDate
                          ))
                      : undefined
                  }
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19_vaccination_campaign_ZH/master/COVID19_Impfungen_pro_Woche_PLZ.csv'
                        target='_blank'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                  footnote={'Ausschlaggebend ist der Wohnort der Infizierten.'}
                >
                  <ColorKey
                    data={[40].concat(scaleVacc.domain()).map(m => ({
                      color: scaleVacc(m) + '',
                      label: m + ''
                    }))}
                  />
                  {drawData && (
                    <PLZMap
                      data={drawData.map(el => {
                        const { vaccRel, plz } = el
                        let color = vaccRel >= 0 ? scaleVacc(vaccRel) : '#eee'
                        return [plz, color, vaccRel, el]
                      })}
                      Tooltip={Tooltip}
                    />
                  )}
                </Chart>
              </div>
            </div>
          )}
          {showTable && drawData && (
            <Chart>
              <Table data={drawData.filter(f => f.casesRel || f.vaccRel)} />
            </Chart>
          )}
          {/* {showTable && (
            <div className='mapwrapper'>
              <div className='left'>
                <Chart
                  title={'Inzidenz und Impfquote'}
                  sub={
                    "Positiv getestete Personen pro 100'000 Personen und Anteil der Bevölkerung, welcher mindestens einmal geimpft ist."
                  }
                  source={
                    <>
                      Quelle:{' '}
                      <a
                        href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_plz/fallzahlen_kanton_ZH_plz.csv'
                        target='_blank'
                      >
                        Gesundheitsdirektion Kanton Zürich
                      </a>
                    </>
                  }
                  update={'Wird montags und donnerstags aktualisiert'}
                  footnote={
                    'Beige = Mit 0-3 Fällen pro Woche zu wenig für eine sinnvolle Berechnung. Für die Berechnung der Inzidenz verwenden wir den Mittelwert der angegebenen Spannbreite der Fälle der Gesundheitsdirektion Zürich. Ausschlaggebend ist der Wohnort der Infizierten.'
                  }
                >
                  <img src={require('./key-01.svg')} />
                  <div className='ColorKey' />
                  {drawData && (
                    <PLZMap
                      data={drawData.map(el => {
                        const { vaccRel, casesRel, plz } = el

                        if (vaccRel && casesRel) {
                          let color = colorizer([casesRel, vaccRel])
                          return [plz, color, [vaccRel, casesRel], el]
                        }

                        return [plz, '#f0f0f0', 0, el]
                      })}
                      Tooltip={Tooltip}
                    />
                  )}
                </Chart>
              </div>
              <div className='right'>
                {drawData && (
                  <Chart update={'Wird montags und donnerstags aktualisiert'}>
                    <Table
                      data={drawData.filter(f => f.casesRel || f.vaccRel)}
                    />
                  </Chart>
                )}
              </div>
            </div>
          )} */}
        </div>
      </div>
    </>
  )
}

const ColorKey = ({ data }: { data: { color: string; label: string }[] }) => {
  return (
    <div className='ColorKey'>
      {data.map((m, i) => (
        <div className='entry' key={'ColorKey_' + i}>
          <div className='swatch' style={{ backgroundColor: m.color }} />
          <div className='label'>{m.label}</div>
        </div>
      ))}
    </div>
  )
}
const Tooltip = ({
  data
}: {
  data: {
    pos: { x: number; y: number }
    data: {
      plz: string
      name: string
      cases: string
      casesRel: number
      caseDate: string
      vacc: number
      vaccDate: string
      vaccRel: number
      pop: number
    }
    size: { w: number; h: number }
  }
}) => {
  const { h } = data.size
  const { y } = data.pos
  const { name, vaccRel, plz, cases, pop, casesRel } = data.data
  return (
    <div className={'Tooltip ' + (y > h / 2 ? 'top' : 'bottom')}>
      <div className='name'>
        {plz} {name}
      </div>
      <div className='pop'>{pop} Einwohner</div>
      <div className='entry'>
        {vaccRel >= 0 && (
          <>
            {' '}
            <div className='vacc'>{vaccRel}%</div>
            <div className='label'>Impfquote </div>
          </>
        )}

        {!vaccRel && (
          <>
            {' '}
            <div className='cases'>n.V.</div>
            <div className='label'>Keine Impfquoteverfügbar</div>
          </>
        )}
      </div>
      <div className='entry'>
        {casesRel > 0 && (
          <>
            <div className='cases'>
              {(cases === '199+' ? '> ' : '') + nF(casesRel)}
            </div>
            <div className='label'>7-T.-Inzidenz</div>
          </>
        )}
        {casesRel === 0 && (
          <>
            {' '}
            <div className='cases'>n.V.</div>
            <div className='label'>
              Nicht genügend Fälle für eine Berechnung
            </div>
          </>
        )}
        {!casesRel && casesRel !== 0 && (
          <>
            <div className='cases'>n.V.</div>
            <div className='label'>Keine Fallzahlen verfügbar</div>
          </>
        )}

        {/* <div className='label'>Neuinfektionen in den letzten 7 Tagen</div>{' '} */}
      </div>

      <div className='entry'>
        {pop && cases && (
          <>
            <div className='cases'>{cases}</div>
            <div className='label'>Fälle auf {nF(pop)} Einwohner</div>
          </>
        )}
      </div>
    </div>
  )
}
const Table = ({ data }: { data: any }) => {
  const [sort, setSort] = useState<
    | 'inzidence'
    | 'plz'
    | 'name'
    | 'vacc'
    | 'inzidence_reverse'
    | 'plz_reverse'
    | 'name_reverse'
    | 'vacc_reverse'
  >('inzidence')
  const sorts = {
    inzidence: (a, b) => (b.casesRel || 0) - (a.casesRel || 0),
    inzidence_reverse: (a, b) => (a.casesRel || 0) - (b.casesRel || 0),
    plz: (a, b) => (a.plz || 0) - (b.plz || 0),
    plz_reverse: (a, b) => (b.plz || 0) - (a.plz || 0),
    name: (a, b) => a.name.localeCompare(b.name),
    name_reverse: (a, b) => b.name.localeCompare(a.name),
    vacc: (a, b) => (b.vaccRel || 0) - (a.vaccRel || 0),
    vacc_reverse: (a, b) => (a.vaccRel || 0) - (b.vaccRel || 0)
  }

  return (
    <div className='Table'>
      <div className='head'>
        <button
          className={
            'plz ' + (sort === 'plz' || sort === 'plz_reverse' ? 'sort' : '')
          }
          onClick={() =>
            sort === 'plz' ? setSort('plz_reverse') : setSort('plz')
          }
        >
          PLZ
        </button>
        <button
          className={
            'name ' + (sort === 'name' || sort === 'name_reverse' ? 'sort' : '')
          }
          onClick={() =>
            sort === 'name' ? setSort('name_reverse') : setSort('name')
          }
        >
          Gemeinde
        </button>{' '}
        <button
          className={
            'cases ' +
            (sort === 'inzidence' || sort === 'inzidence_reverse' ? 'sort' : '')
          }
          onClick={() =>
            sort === 'inzidence'
              ? setSort('inzidence_reverse')
              : setSort('inzidence')
          }
        >
          Inzidenz
        </button>
        <button
          className={
            'vacc ' + (sort === 'vacc' || sort === 'vacc_reverse' ? 'sort' : '')
          }
          onClick={() =>
            sort === 'vacc' ? setSort('vacc_reverse') : setSort('vacc')
          }
        >
          Impfquote
        </button>
      </div>
      <div className='content'>
        <div className='rows'>
          {data.sort(sorts[sort]).map((m, i) => {
            const { name, plz, casesRel, vaccRel } = m

            return (
              <div className='row' key={'Table_' + i}>
                <div className='plz'>{plz}</div>
                <div className='name'>{name} </div>
                <div className='cases'>{casesRel || 'n.V.'}</div>

                <div className='vacc'>{vaccRel}%</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
